/*
 * @Author: 张天昊
 * @Date: 2024-05-25 13:57:18
 * @LastEditTime: 2024-05-25 14:23:50
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/pages/itineraryUniversal/composables/useSpotListBarScroll.js
 */
import { ref, watch, computed } from 'vue';
import { scrollLeftTo } from '@/utils/scroll';

export function useSpotListBarScroll(current) {
  const containerEl = ref();
  const itemEls = ref();
  const currentItemEl = computed(() => {
    if (itemEls.value && itemEls.value.length) {
      return itemEls.value[current.value];
    }
    return null;
  });

  watch(
    currentItemEl,
    (el) => {
      /**
       * 激活时滚动到视口内
       * 实现同vant tabs
       */
      const parent = containerEl.value;
      if (parent && el) {
        const to = el.offsetLeft - (parent.offsetWidth - el.offsetWidth) / 2;
        scrollLeftTo(parent, to, 0.2);
      }
    },
    {
      immediate: true
    }
  );

  return {
    containerEl,
    itemEls
  };
}
